const routes = [
    {
        path: '/mber-sbsr',
        name: 'MberSbsr',
        meta: {
            layout: 'blank'
        },
        component: () => import(/* webpackChunkName: "main" */ '@/views/mber-sbsr/mber-sbsr.vue'),
    },
    {
        path: '/mber-sbsr/mber-sbsr-compt',
        name: 'MberSbsrCompt',
        meta: {
            layout: 'blank'
        },
        component: () => import(/* webpackChunkName: "main" */ '@/views/mber-sbsr/mber-sbsr-compt.vue'),
    },
]

export default routes;